import React from 'react';
import * as style from './Header.module.css';

import NavBar from '../NavBar';

function Header() {
  return <NavBar />;
}

export default Header;
